import { DispatchProps, OwnProps } from 'component/common/ActivityPOICard/ActivityPOICard.types';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesPoiCardHoverEventActivitiesFieldsV1, ActivitiesPoiCardSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesPoiCardHoverEventActivitiesManifestV1, ActivitiesPoiCardSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { Dispatch } from '@reduxjs/toolkit';

export const mapDispatchToProps = (_dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
    onSeen: () => {
        const { poi, index } = ownProps;
        trackElementEvent<ActivitiesPoiCardSeenEventActivitiesFieldsV1>(
            ActivitiesPoiCardSeenEventActivitiesManifestV1.ids,
            {
                activities_ids: poi.activities?.map((activity) => activity.id),
            },
            {
                action_element_index: index + 1,
                action_element_value: poi.id.toString(),
            },
        );
    },
    onHover: () => {
        const { poi, index } = ownProps;
        trackElementEvent<ActivitiesPoiCardHoverEventActivitiesFieldsV1>(
            ActivitiesPoiCardHoverEventActivitiesManifestV1.ids,
            {
                activities_ids: poi.activities?.map((activity) => activity.id),
            },
            {
                action_element_index: index + 1,
                action_element_value: poi.id.toString(),
            },
        );
    },
});
